import { Component, OnInit } from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {DialogDeleteComponent} from '@app/_shared/dialogs/delete/dialog-delete.component';
import {lang} from '../../school-years.lang';

const dataElement = [
  {id: 1, fullname: 'Sở giáo dục Hà Nội', code: 'OMT029', domain: 'SDGhanoi.com.vn', phone: '045677983', email: 'info@omt.edu.vn', status: 1},
  {id: 1, fullname: 'Sở giáo dục Hà Nội', code: 'OMT029', domain: 'SDGhanoi.com.vn', phone: '045677983', email: 'info@omt.edu.vn', status: 0},
  {id: 1, fullname: 'Sở giáo dục Hà Nội', code: 'OMT029', domain: 'SDGhanoi.com.vn', phone: '045677983', email: 'info@omt.edu.vn', status: 0},
  {id: 1, fullname: 'Sở giáo dục Hà Nội', code: 'OMT029', domain: 'SDGhanoi.com.vn', phone: '045677983', email: 'info@omt.edu.vn', status: 0},
  {id: 1, fullname: 'Sở giáo dục Hà Nội', code: 'OMT029', domain: 'SDGhanoi.com.vn', phone: '045677983', email: 'info@omt.edu.vn', status: 1},
  {id: 1, fullname: 'Sở giáo dục Hà Nội', code: 'OMT029', domain: 'SDGhanoi.com.vn', phone: '045677983', email: 'info@omt.edu.vn', status: 0},

];

@Component({
  selector: 'app-tab-list-customer',
  templateUrl: './tab-list-customer.component.html',
  styleUrls: ['./tab-list-customer.component.scss']
})
export class TabListCustomerComponent implements OnInit {
  data = dataElement;
  displayedColumns: string[] = ['stt', 'fullname', 'code', 'domain', 'phone', 'email', 'status', 'tools'];
  length = this.data.length;
  lang = lang;
  constructor(
      private dialog: MatDialog,
  ) { }

  ngOnInit(): void {
  }

  openDialogDelete(data){
    const dialogRef = this.dialog.open(DialogDeleteComponent, {
      height:'auto',
      width:'40%',
      data: {
        title:'Bạn đang thực hiện xóa khách hàng khỏi khối 1',
        message:'Xác nhận xóa?',
        btnOkText:'Delete',
        btnCancelText:'Cancel',
        data: {
          name:`${data.fullname} (${data.code})`,
        },
        html:`<img src="https://1.bp.blogspot.com/-nHl_GqUD718/XngOmetGs8I/AAAAAAAAZp4/yj0qV6QnG4Ib_smhD0RN6H3hu1NoafpAgCLcBGAsYHQ/s1600/Avatar-Facebook%2B%25283%2529.jpg" alt="Girl in a jacket">`
      }
    })
  }



}
